/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'mustache',
    'pip-model',
    'thd-overlay'
],
function(
    Mustache,
    pip,
    thdOverlay
){

    var fbtIrgAtcConfirmation;

	var template = '\
		<div class="multi-atc-overlay pip-row no-gutters">\
		    <div class="col-12 col-sm-6">\
		        <a class="bttn-outline bttn-outline--primary bttn--inline" id="continue_shopping"><span class="bttn__content">CONTINUE SHOPPING</span></a>\
		    </div>\
		    <div class="col-12 col-sm-6">\
                <a class="bttn-outline bttn-outline--primary bttn--inline" href="/mycart/home"><span class="bttn__content">CHECKOUT NOW</span></a>\
            </div>\
		</div>';

	var errorTemplate = '<div class="multi-atc-overlay--error" style="text-align:center; padding:25px;"><h2>One or more items were not added to your cart. <br/>Please verify your items in cart.</h2></div>';

	return {
		display: function(data) {
			if (data) {

                var fbtIrgAtcConfirmationContent= document.createElement('div');
                fbtIrgAtcConfirmationContent.innerHTML = Mustache.to_html(template, data);

                fbtIrgAtcConfirmation = new thdOverlay({
                    speed: '500ms',
                    useContent: true,
                    channel: pip.platform.toLowerCase(),
                    header: true,
                    title: Mustache.render('<p class="message b"><span class="pip-icons checkmark"></span><span>{{items}}</span> Item(s) have been added to cart.</p>', data),
                    htmlNode: fbtIrgAtcConfirmationContent
                });
				fbtIrgAtcConfirmation.open();

                $(document).off('click.multiATC');
				$(document).on('click.multiATC', '#continue_shopping', function (e) {
				    e.preventDefault();
                    fbtIrgAtcConfirmation.close();
                });
			}
		},
		displayError: function(){
            var fbtIrgAtcConfirmationContent= document.createElement('div');
            fbtIrgAtcConfirmationContent.innerHTML = errorTemplate;

            fbtIrgAtcConfirmation = new thdOverlay({
                speed: '500ms',
                useContent: true,
                channel: pip.platform.toLowerCase(),
                header: true,
                title: '',
                htmlNode: fbtIrgAtcConfirmationContent
            });
            fbtIrgAtcConfirmation.open();
        },
        getAnalyticsAtcOverlayEventData: function(data, atcItems) {
            var items=[];
            data.forEach( function(item) {
                for(var i=0; i<atcItems.length; i++){
                    if (item.itemId === atcItems[i]){
                        var actualOfferPrice = item.specialOfferPrice || item.unitPrice;
                        var itemInfo = {
                            productInfo: { sku: item.itemId },
                            quantity: item.quantity,
                            price: { basePrice: actualOfferPrice.toString() },
                            fulfillment: {
                                method: item.fulfillmentModel[0].fulfillmentMethod
                            }
                        };
                        if ( item.fulfillmentModel[0].fulfillmentMethod === 'BOPIS' || item.fulfillmentModel[0].fulfillmentMethod === 'BOSS' ) {
                            itemInfo.fulfillment.store = item.fulfillmentModel[0].pickUpStore;
                        }
                        if ( item.fulfillmentModel[0].fulfillmentMethod === 'BODFS'){
                            itemInfo.fulfillment.zip = item.fulfillmentModel[0].zipCode;
                        }
                        items.push(itemInfo);
                    }
                }
            });
            return {itemsModel: items}
        }

	}


});

}.call(window));